import { useQuery } from '@tanstack/react-query';
import { dashboard } from '@/utils/api';

export function useDashboardStats() {
  return useQuery({
    queryKey: ['dashboard'],
    queryFn: () => dashboard.get().then((r) => r.data),
  });
}
